import React from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import OrderListScreen from '../screens/order/OrderListScreen';
import OrderViewScreen from '../screens/order/OrderViewScreen';
import OrderCreateScreen from '../screens/order/OrderCreateScreen';
import SelectItemScreen from '../screens/order/SelectItemScreen';
import OrderLineDetailScreen from '../screens/order/OrderLineDetailScreen';
import AddOnSelectorScreen from '../screens/order/AddOnSelectorScreen';
import SalesStaffSelectorScreen from '../screens/order/SalesStaffSelectorScreen';
import MeasurementFormScreen from '../screens/measurement/MeasurementFormScreen';
import MeasurementProfileSelectorScreen from '../screens/order/MeasurementProfileSelectorScreen';
import CatalogItemOptionTypesScreen from '../screens/measurement/CatalogItemOptionTypesScreen';
import OptionSelectionScreen from '../screens/order/OptionSelectionScreen';
import InstanceTaskScreen from '../screens/order/InstanceTaskScreen';
import OrderLineInstanceViewScreen from '../screens/order/OrderLineInstanceViewScreen';
import OrderBillScreen from '../screens/order/OrderBillScreen';
import OrderSearchFiltersScreen from '../screens/order/OrderSearchFiltersScreen';
import OrderSearchResultsScreen from '../screens/order/OrderSearchResultsScreen';
import CustomerFormScreen from '../screens/customer/CustomerFormScreen';

const Stack = createNativeStackNavigator();

const OrderNavigator = () => {
  return (
    <Stack.Navigator screenOptions={{headerShown: false}}>
      <Stack.Screen name="OrderList" component={OrderListScreen} />
      <Stack.Screen name="OrderView" component={OrderViewScreen} />
      <Stack.Screen name="OrderCreate" component={OrderCreateScreen} />
      <Stack.Screen name="CustomerForm" component={CustomerFormScreen} />
      <Stack.Screen name="SelectItem" component={SelectItemScreen} />
      <Stack.Screen name="OrderLineDetail" component={OrderLineDetailScreen} />
      <Stack.Screen name="AddOnSelector" component={AddOnSelectorScreen} />
      <Stack.Screen name="SalesStaffSelector" component={SalesStaffSelectorScreen} />
      <Stack.Screen name="MeasurementProfileSelector" component={MeasurementProfileSelectorScreen} />
      <Stack.Screen name="MeasurementForm" component={MeasurementFormScreen} />
      <Stack.Screen name="CatalogItemOptionTypes" component={CatalogItemOptionTypesScreen} />
      <Stack.Screen name="OptionSelection" component={OptionSelectionScreen} />
      <Stack.Screen name="InstanceTask" component={InstanceTaskScreen} />
      <Stack.Screen name="OrderLineInstanceView" component={OrderLineInstanceViewScreen} />
      <Stack.Screen name="OrderBill" component={OrderBillScreen} />
      <Stack.Screen name="OrderSearchFilters" component={OrderSearchFiltersScreen} />
      <Stack.Screen name="OrderSearchResults" component={OrderSearchResultsScreen} />
    </Stack.Navigator>
  );
};

export default OrderNavigator;
